/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Stock } from './Stock';
import {
    StockFromJSON,
    StockFromJSONTyped,
    StockToJSON,
} from './Stock';

/**
 * 
 * @export
 * @interface GetStocks200ResponseAllOfData
 */
export interface GetStocks200ResponseAllOfData {
    /**
     * 
     * @type {Array<Stock>}
     * @memberof GetStocks200ResponseAllOfData
     */
    stocks: Array<Stock>;
}

/**
 * Check if a given object implements the GetStocks200ResponseAllOfData interface.
 */
export function instanceOfGetStocks200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stocks" in value;

    return isInstance;
}

export function GetStocks200ResponseAllOfDataFromJSON(json: any): GetStocks200ResponseAllOfData {
    return GetStocks200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetStocks200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStocks200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stocks': ((json['stocks'] as Array<any>).map(StockFromJSON)),
    };
}

export function GetStocks200ResponseAllOfDataToJSON(value?: GetStocks200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stocks': ((value.stocks as Array<any>).map(StockToJSON)),
    };
}

